import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OrganizationUserDetailValidationResult } from "@idw-types/data/axn-admin-user";
import styles from "./validation-error-component.less";

type ValidationErrorComponentProps = {
    validation: OrganizationUserDetailValidationResult;
}

export const ValidationErrorComponent = ({ validation }: ValidationErrorComponentProps) => {
    const { valid, errorMessage } = validation;
    const color = valid ? 'green' : 'red';
    const icon = valid ? faCheck : faTimes;

    return <div className={styles.validationError} style={{ color }}>
        <FontAwesomeIcon className={styles.icon} icon={icon} color={color} />
        <span>{errorMessage}</span>
    </div>

}